// extracted by mini-css-extract-plugin
module.exports = {"eventDescription":"mTkjA","sideBySide":"_33MpG","descriptionSpacing":"_1i1nB"};